import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/system';
import { useTheme } from '@mui/material/styles';

import { BORDER, HOVER_BG, SANS_STACK } from '../tokens';

/**
 * The segmented filter that narrows the grid below it in place.
 */
export default function ScopeControl({ options, value, onChange }) {
  const theme = useTheme();

  return (
    <Box sx={{
      display: 'inline-flex',
      border: `1.5px solid ${BORDER}`,
      borderRadius: '8px',
      overflow: 'hidden',
      flexShrink: 0,
    }}>
      {options.map((option, index) => {
        const selected = option.value === value;
        const disabled = Boolean(option.disabled) && !selected;
        return (
          <Box
            key={option.value}
            component="button"
            type="button"
            title={option.title}
            disabled={disabled}
            aria-pressed={selected}
            onClick={() => onChange(option.value)}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '5px 13px',
              border: 'none',
              cursor: disabled ? 'default' : 'pointer',
              fontFamily: SANS_STACK,
              fontSize: 12,
              fontWeight: 700,
              ...(index > 0 && { boxShadow: `inset 1px 0 0 ${BORDER}` }),
              ...(selected && {
                background: theme.palette.primary.main,
                color: '#fff',
              }),
              ...(!selected && !disabled && {
                background: '#fff',
                color: '#3c3c3c',
                '&:hover': { background: HOVER_BG },
              }),
              ...(disabled && {
                background: '#fff',
                color: '#3c3c3c',
                opacity: 0.42,
              }),
            }}
          >
            {option.label}
            {option.count != null && (
              <Box component="span" sx={{ opacity: 0.72 }}>{option.count}</Box>
            )}
          </Box>
        );
      })}
    </Box>
  );
}

ScopeControl.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    count: PropTypes.number,
    title: PropTypes.string,
    disabled: PropTypes.bool,
  })).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

ScopeControl.defaultProps = {
  value: null,
};
